const Test = () => import('../views/Test.vue')

export default [
  {
    path: 'candidate/tests',
    component: Test,
    meta: { requiresAuth: true },
    name: 'candidate.test'
  }
]